import React, { Component } from "react"
import { withStyles } from "@material-ui/core"

import { Cookies } from "react-cookie"
import Grid from "@material-ui/core/Grid"
import Divider from "@material-ui/core/Divider"
import FloatingLabelInput from "./FloatingLabelInput"
import Select from "react-select"
import Button from "@material-ui/core/Button"
import Fab from "@material-ui/core/Fab"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert, AlertTitle } from "@material-ui/lab"
import * as constants from "../constants"

const styles = (theme) => ({
      button: {
            margin: theme.spacing.unit,
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class BodyCarThirdparty extends Component {
      cookies = new Cookies()
      constructor(props) {
            super(props)

            this.state = {
                  bodycarThirdpartyState: this.props.bodycarThirdparty,
                  selectedBodycarThirdparty: {
                        value: this.props.bodycarThirdparty.bodycar_price_thirdparty_bodycar_discnt_thirdparty_id,
                        label: this.props.bodycarThirdparty.bodycar_discnt_thirdparty_name,
                  },
                  visible: true,
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  optionBodycarThirdparty: [],
            }
      }
      componentDidMount() {
            this.getoptionBodycarThirdparty()
      }

      getoptionBodycarThirdparty = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].bodycar_discnt_thirdparty_id,
                                          label: arr.data[k].bodycar_discnt_thirdparty_name,
                                    })
                              }
                              self.setState({ optionBodycarThirdparty: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_discnt_thirdparty")
            xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
            xhttp.send(fd)
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleInstalmentMode = (selectedBodycarThirdparty) => {
            var temparray = this.state.bodycarThirdpartyState
            temparray.bodycar_price_thirdparty_bodycar_discnt_thirdparty_id = selectedBodycarThirdparty.value
            this.setState({ selectedBodycarThirdparty: selectedBodycarThirdparty, bodycarThirdpartyState: temparray })
      }

      handleChangeConditionsPercent = (event) => {
            var temparray = this.state.bodycarThirdpartyState
            temparray.bodycar_price_thirdparty_percent = event
            this.setState({ bodycarThirdpartyState: temparray })
      }

      modifyNewInstalmentCondition = () => {
            const { bodycarThirdpartyState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_pricethirdparty")
            fd.append("bodycar_price_thirdparty_id", bodycarThirdpartyState.bodycar_price_thirdparty_id)
            fd.append("bodycar_price_thirdparty_percent", bodycarThirdpartyState.bodycar_price_thirdparty_percent)
            xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deleteInstalmentCondition = () => {
            const { bodycarThirdpartyState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ visible: false, snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_pricethirdparty")
            fd.append("bodycar_price_thirdparty_id", bodycarThirdpartyState.bodycar_price_thirdparty_id)

            xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      render() {
            const { classes } = this.props
            const { optionBodycarThirdparty, snackMode, snackstr, showSnack, visible, selectedBodycarThirdparty, bodycarThirdpartyState } = this.state
            if (visible) {
                  return (
                        <Grid container spacing={3}>
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>

                              <Grid item xs={5}>
                                    <div>
                                          <label className="on"> تخفیف بیمه ثالث</label>
                                          <Select
                                                isSearchable={true}
                                                className="adapter-txtsize"
                                                placeholder={"تخفیف بیمه ثالث"}
                                                value={selectedBodycarThirdparty}
                                                onChange={this.handleInstalmentMode}
                                                options={optionBodycarThirdparty}
                                          />
                                    </div>
                              </Grid>

                              <Grid item xs={4}>
                                    <FloatingLabelInput
                                          type="percent"
                                          placeholder="درصد تخفیف ثالث روی تخفیف بیمه بدنه "
                                          handleInputt={this.handleChangeConditionsPercent}
                                          value={bodycarThirdpartyState.bodycar_price_thirdparty_percent}
                                    />
                              </Grid>

                              <Grid item xs={3}>
                                    <div style={{ width: "100%", textAlign: "left" }}>
                                          <Fab
                                                className={classes.small}
                                                style={{ background: "#44b700" }}
                                                aria-label="edit"
                                                onClick={this.modifyNewInstalmentCondition}
                                          >
                                                <EditIcon />
                                          </Fab>

                                          <Fab className={classes.small} color="secondary" aria-label="edit" onClick={this.deleteInstalmentCondition}>
                                                <DeleteIcon />
                                          </Fab>
                                    </div>
                              </Grid>
                              <Grid item xs={12}>
                                    <Divider />
                              </Grid>
                        </Grid>
                  )
            } else {
                  return null
            }
      }
}
export default withStyles(styles)(BodyCarThirdparty)
